<template>
    <div v-html="config.html" />
</template>

<script>
export default {
    mixins: [Fieldtype]
};
</script>
